import {Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {Globals} from '../../../services/globals.service';
import {MockDataService} from '../../../services/mock-data.service';
import {UserService} from '../../../services/user.service';
import {PowercheckerStateService} from '../../../services/powerchecker-state.service';
import {PowerCheckerService} from '../../../services/powerchecker.service';
import {ApplicationService} from '../../../services/application.service';
import {TILE_TYPE, TileService} from '../../../services/tile.service';
import {TrackAnalyticsService} from '../../../services/track-analytics.service';

@Component({
    selector: 'app-powerchecker-tile',
    templateUrl: './powerchecker-tile.component.html',
    styleUrls: ['./powerchecker-tile.component.scss'],
    providers: [Globals]
})

export class PowerCheckerTileComponent implements OnInit, OnDestroy {
    private readonly type: TILE_TYPE = TILE_TYPE.POWER_CHECKER;

    plugAttributes = {
        name: '',
        room: ''
    };

    plugName = 'Mein Gerät';
    plugRoom = 'Mein Zimmer';

    state = false;

    subscriptions = [];

    @ViewChild('switchToggle', {static: true}) switchToggle: ElementRef;
    private changeObserver: MutationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes') {
                const checked = mutation.target['checked'];
                this.onStateChange(checked);
            }
        });
    });

    constructor(private _apiService: ApiService,
                private _globals: Globals,
                private _mockData: MockDataService,
                private _userService: UserService,
                private powercheckerState: PowercheckerStateService,
                private powerchecker: PowerCheckerService,
                private application: ApplicationService,
                private analytics: TrackAnalyticsService,
                private tiles: TileService,
                private renderer: Renderer2) {
    }

    ngOnInit() {
        this.initPlugAttributes();
        this.getPlugAttributes();

        // subscribe to external changes
        this._userService.plugAttributesChanged.subscribe(
            (values: any) => {
                this.plugAttributes = values;
                this.plugName = this.plugAttributes.name;
                this.plugRoom = this.plugAttributes.room;
            }
        );

        // subscribe to state changes
        this.powercheckerState.stateChange.subscribe(
            (value) => {
                this.state = value;
            }
        );

        // let the change mutation observer do its job
        this.changeObserver.observe(this.switchToggle.nativeElement, {attributeFilter: ['checked']});


        if (this.application.isDemoMode()) {
            this._mockData.getPlugStatus().subscribe(
                (response: any) => {
                    this.state = response.data.on_off === 1;
                }
            );
            return;
        }
        this.initPowerCheckerStateChange();
    }

    ngOnDestroy() {
        this.changeObserver.disconnect();
    }


    onTileClicked(event): void {
        if (event.target.id === 'switch') {
            return;
        }
        this.detailEntered();
        this.tiles.openDetailView(this.type);
    }

    onTileRemoveClicked(): void {
        this.tiles.setSelected(false, this.type, true);
    }

    /**
     * Initialize the plugs attributes
     */
    private initPlugAttributes(): void {
        this.plugAttributes = this._userService.getPlugAttributes();
        if (this.plugAttributes === null || this.plugAttributes === undefined) {
            this.getPlugAttributes();
            return;
        }

        this.plugName = this.plugAttributes.name;
        this.plugRoom = this.plugAttributes.room;
    }

    private getPlugAttributes(): void {
        if (!this.application.isDemoMode()) {
            const sub = this._apiService.getStoredUserSettings().subscribe(
                (response) => {
                    if (response) {
                        this.plugAttributes = response.power_checker;
                        if ('power_checker' in response) {
                            if ('name' in response.power_checker && 'room' in response.power_checker) {
                                if (this.plugAttributes.name !== '') {
                                    this.plugName = this.plugAttributes.name;
                                }
                                if (this.plugAttributes.room !== '') {
                                    this.plugRoom = this.plugAttributes.room;
                                }
                                this._userService.updatePlugAttributes(response.power_checker);
                            }
                        } else {
                            console.log('PC Settings appear to be empty');
                        }
                    }
                }
            );
            this.subscriptions.push(sub);
        }
    }

    onStateChange(state: boolean): void {
        this.state = state;
        this.powercheckerState.stateChange.next(state);
        if (!this.application.isDemoMode()) {
            this.powerchecker.setState(state ? 1 : 0).subscribe(
                // this._apiService.setPlugStatus(state ? 1 : 0).subscribe(
                (res) => {
                    if (res) {
                        if ('relay' in res) {
                            if ('on_off' in res) {
                                const value = res.relay.on_off;
                                this.state = value === 1;
                            }
                        }
                    }
                },
                (error) => {
                }
            );
            return;
        }
    }

    detailEntered() {
        if (!(this._globals.getFirstDetailsViewed())) {
            this.trackFirstDetailView();
        }
        this._globals.setFirstDetailsViews();
        this.trackDetailsEntered();
    }

    private initPowerCheckerStateChange(): void {
        const s = this.powerchecker.getState().subscribe(
            // const sub = this._apiService.getPlugStatus().subscribe(
            (res) => {
                if (res) {
                    if ('relay' in res) {
                        if ('on_off' in res.relay) {
                            const value = res.relay.on_off;
                            this.state = value === 1;
                        }
                    }
                }
            }
        );
        this.subscriptions.push(s);
    }

    private trackDetailsEntered(): void {
        this.analytics.trackEvent({
            action: 'dashboard_tile_tapped',
            properties: {
                category: 'Tiles',
                label: 'Tile: E.ON Smart Control Stecker'
            }
        });
    }

    private trackFirstDetailView(): void {
        // Erstes aufrufen eines Detail Screens
        this.analytics.trackEvent({
            action: 'first_detail_view',
            properties: {
                category: 'Screens',
                label: 'Screen: Powerchecker-Details'
            }
        });
    }

}
